/*
 * Purpose: Mobile bottom tab bar — P0 AppShell
 * Last modified: 2026-06-28 | Agent
 * Completeness: 92
 */
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Sparkles, FolderOpen, Map, Plug } from 'lucide-react';
import { PRIMARY_NAV, matchPrimaryNav, type PrimaryNavId } from '@/lib/primaryNav';
import { cn } from '@/lib/utils';

const ICONS: Record<PrimaryNavId, typeof LayoutDashboard> = {
  dashboard: LayoutDashboard,
  compose: Sparkles,
  flows: FolderOpen,
  mission: Map,
  connect: Plug,
};

export function MobileNav() {
  const { pathname } = useLocation();
  const active = matchPrimaryNav(pathname);

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-border bg-background/95 backdrop-blur-sm pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary mobile"
    >
      <div className="flex items-stretch justify-around">
        {PRIMARY_NAV.map((item) => {
          const Icon = ICONS[item.id];
          const isActive = active === item.id;
          return (
            <Link
              key={item.id}
              to={item.href}
              className={cn(
                'flex flex-1 flex-col items-center gap-0.5 py-2 px-1 text-[10px] font-medium transition-colors min-h-[52px] justify-center',
                isActive
                  ? 'text-[hsl(var(--ab-green-deep))] dark:text-[hsl(var(--ab-green-glow))]'
                  : 'text-muted-foreground'
              )}
            >
              <Icon className={cn('h-5 w-5', isActive && 'scale-105')} />
              <span className="truncate max-w-[4.5rem]">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileNav;
